import React, { useState } from "react";
import { Play, X } from "lucide-react";

export default function VideoSection({ videos }) {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="py-24 md:py-32 bg-[#f5ebd6]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[12px] tracking-tight-wide text-[#a08862] font-semibold">
            {videos.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#2a2a2a] mt-4">
            {videos.title}
          </h2>
          <div className="divider-line" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videos.items.map((v) => (
            <button
              key={v.id}
              onClick={() => setActive(v)}
              className="relative group overflow-hidden aspect-[16/10] block"
            >
              <img
                src={v.thumbnail}
                alt={v.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-[#a08862]/85 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Play className="w-7 h-7 text-white ml-1" fill="white" />
                </div>
              </div>
              <div className="absolute bottom-5 left-5 text-white font-serif-display text-xl text-left">
                {v.title}
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-white hover:text-[#a08862]"
          >
            <X size={32} />
          </button>
          <div
            className="relative w-full max-w-5xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1`}
              title={active.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}
